import { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import FacebookIcon from "@mui/icons-material/Facebook";
import WebsiteIntegrationModal from "./WebsiteIntegrationModal";

const SettingsIntegrations = () => {
  const [openWebsite, setOpenWebsite] = useState(false);
  const [openMeta, setOpenMeta] = useState(false);

  return (
    <Box>
      <Grid container spacing={2}>
        {/* Website */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Box
            sx={{
              border: "1px solid",
              borderColor: "divider",
              p: 2,
              borderRadius: 2,
              bgcolor: "background.paper",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 1.5,
                  bgcolor: "#E3F2FD",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <LanguageIcon sx={{ color: "#1976D2" }} />
              </Box>
              <Typography fontWeight={600}>Website</Typography>
            </Box>

            <Typography variant="body2" color="text.secondary" mt={1}>
              Receive website leads via POST API.
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Box
                onClick={() => setOpenWebsite(true)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  cursor: "pointer",
                  color: "primary.main",
                }}
              >
                <SettingsOutlinedIcon fontSize="small" />
                <Typography variant="body2">Manage</Typography>
              </Box>

              <Switch size="small" />
            </Box>
          </Box>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Box
            sx={{
              border: "1px solid",
              borderColor: "divider",
              p: 2,
              borderRadius: 2,
              bgcolor: "background.paper",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 1.5,
                  bgcolor: "#E7F3FF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FacebookIcon sx={{ color: "#1877F2" }} />
              </Box>
              <Typography fontWeight={600}>Meta Ads</Typography>
            </Box>

            <Typography variant="body2" color="text.secondary" mt={1}>
              Sync Facebook & Instagram lead ads with CRM.
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Box
                onClick={() => setOpenMeta(true)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  cursor: "pointer",
                  color: "primary.main",
                }}
              >
                <SettingsOutlinedIcon fontSize="small" />
                <Typography variant="body2">Manage</Typography>
              </Box>

              <Switch size="small" disabled />
            </Box>
          </Box>
        </Grid>
      </Grid>

      <WebsiteIntegrationModal
        open={openWebsite}
        onClose={() => setOpenWebsite(false)}
      />

      <Dialog
        open={openMeta}
        onClose={() => setOpenMeta(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Meta Ads Integration</DialogTitle>

        <DialogContent>
          <Typography fontWeight={600} mb={1}>
            Assisted Setup Required
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Meta Ads integration requires business verification and secure
            access to your Facebook ad accounts. Our team will help you complete
            the setup safely and correctly.
          </Typography>

          <Box
            mt={3}
            p={2}
            border="1px dashed"
            borderColor="divider"
            borderRadius={2}
          >
            <Typography variant="body2">
              Please contact support with:
            </Typography>
            <ul style={{ marginTop: 8, paddingLeft: 20 }}>
              <li>Facebook Business Manager ID</li>
              <li>Ad Account ID</li>
              <li>CRM Account Name</li>
            </ul>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenMeta(false)}>Close</Button>
          <Button variant="contained">Contact Support</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SettingsIntegrations;
